import { render } from "./MenuAdmin.vue?vue&type=template&id=40ca7053&scoped=true"
import script from "./MenuAdmin.vue?vue&type=script&lang=js"
export * from "./MenuAdmin.vue?vue&type=script&lang=js"

import "./MenuAdmin.vue?vue&type=style&index=0&id=40ca7053&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40ca7053"

export default script